'use strict';

var _ = require('lodash');
var DtdFilteringService = function DtdFilteringService() {
  var MAX_DTD = 1000;
  var MIN_DTD = -1000;
  var EXCLUSION_OPERATORS = ['Not Between', '!='];
  var RANGE_CONVERSIONS = {
    '=': function _(criteria) {
      return [[criteria.leftOperand, criteria.leftOperand]];
    },
    '!=': function _(criteria) {
      return [[MIN_DTD, criteria.leftOperand - 1], [criteria.leftOperand + 1, MAX_DTD]];
    },
    '<': function _(criteria) {
      return [[MIN_DTD, criteria.leftOperand - 1]];
    },
    '<=': function _(criteria) {
      return [[MIN_DTD, criteria.leftOperand]];
    },
    '>': function _(criteria) {
      return [[criteria.leftOperand + 1, MAX_DTD]];
    },
    '>=': function _(criteria) {
      return [[criteria.leftOperand, MAX_DTD]];
    },
    'Not Between': function Not_Between(criteria) {
      return [[MIN_DTD, criteria.leftOperand - 1], [criteria.rightOperand + 1, MAX_DTD]];
    },
    'Between': function Between(criteria) {
      return [[criteria.leftOperand, criteria.rightOperand]];
    }
  };

  /**
   * Each criteria object will be converted to a set of ranges. Exclusive operator values will be converted to inclusive ranges.
   * @param criteria
   * @returns {*}
   */
  function convertToRange(criteria) {
    return RANGE_CONVERSIONS[criteria.operator](criteria);
  }

  /**
   * Check if number is contained in one of the ranges
   * @param dtdNumber
   * @param ranges
   * @returns {boolean}
   */
  function checkRanges(dtdNumber, ranges) {
    var valid = false;
    _.forEach(ranges, function (range) {
      if (dtdNumber >= range[0] && dtdNumber <= range[1]) {
        valid = true;
      }
    });
    return valid;
  }

  /**
   * Return true if number matches ANY of the range arrays. If mode is set to 'AND' , it will return true only if number
   * matches ALL validation ranges;
   * @param dtdNumber number to validate
   * @param ranges array of ranges to validate against
   * @param mode {&|undefined}
   * @returns {boolean}
   */
  function validateRanges(dtdNumber, ranges, mode) {
    var AND_MODE = mode === 'AND';
    var valid = AND_MODE;
    _.forEach(ranges, function (range) {
      var compResult = checkRanges(dtdNumber, range);
      if (AND_MODE ? !compResult : compResult) {
        valid = compResult;
      }
    });
    return valid;
  }
  function filterByDtd(items, dtdCriteria) {
    var groupedCriteria = _.partition(dtdCriteria, function (item) {
      return EXCLUSION_OPERATORS.indexOf(item.operator) === -1;
    });
    var inclusionCriteria = groupedCriteria[0];
    var exclusionCriteria = groupedCriteria[1];
    var inclusionRanges = _.chain(inclusionCriteria).transform(function (result, item) {
      result.push(convertToRange(item));
    }, []).value();
    var exclusionRanges = _.chain(exclusionCriteria).transform(function (result, item) {
      result.push(convertToRange(item));
    }, []).value();
    return _.filter(items, function (legCabin) {
      var inclusionValid = inclusionRanges.length ? validateRanges(legCabin.daysToDeparture, inclusionRanges) : true;
      var exclusionValid = exclusionRanges.length ? validateRanges(legCabin.daysToDeparture, exclusionRanges, 'AND') : true;
      return inclusionValid && exclusionValid;
    });
  }
  return {
    validateRanges: validateRanges,
    filterByDtd: filterByDtd
  };
};
DtdFilteringService.$inject = [];
module.exports = DtdFilteringService;